import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { getAvailabilityManagementUrl } from 'conversations-external-deep-links/urls';
import { HELPDESK } from '../../shared/constants/workspaces';
import { KEEP_ASSIGNEE } from '../constants/RoutingTypes';
import { getRotationMethod, getType } from '../operators/routingRulesGetters';
import { buildRoutingRulesFromType } from '../utils/buildRoutingRulesFromType';
import RuleBox from './RuleBox';
import SelectAssignmentGroup from './SelectAssignmentGroup';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentLabel = ({
  workSpace,
  hasEditAccess,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  // If gated for HelpDeskRoutingScopeFiltering, everything remains the same as before
  if (!isUngatedForHelpDeskRoutingScopeFiltering) {
    const tooltipCommon = {
      elements: {
        UILink
      },
      options: {
        external: true,
        href: getAvailabilityManagementUrl()
      }
    };
    let label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.routingRules.assignment.label.generic"
    });
    let tooltip = /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.seats.generic_jsx"
    }, tooltipCommon));
    if (workSpace === HELPDESK) {
      label = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.routingRules.assignment.label.tickets"
      });
      tooltip = /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
        message: "routing-ui.routingRules.assignment.seats.tickets_jsx"
      }, tooltipCommon));
    }
    return /*#__PURE__*/_jsx(UIHelpIcon, {
      title: tooltip,
      children: label
    });
  } else {
    const tooltipCommon = {
      elements: {
        UILink
      },
      options: {
        external: true,
        href: getUsersSeatsUrl()
      }
    };
    let label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.routingRules.assignment.label.generic"
    });
    let tooltip = /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.seats.generic_jsx"
    }, tooltipCommon));
    if (workSpace === HELPDESK) {
      label = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.routingRules.assignment.label.tickets"
      });
      tooltip = /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
        message: "routing-ui.routingRules.assignment.seats.ticketsTooltip_jsx"
      }, tooltipCommon));
      return hasEditAccess ? /*#__PURE__*/_jsx(UIHelpIcon, {
        title: tooltip,
        children: label
      }) : label;
    }
    return /*#__PURE__*/_jsx(UIHelpIcon, {
      title: tooltip,
      children: label
    });
  }
};
AssignmentLabel.displayName = 'AssignmentLabel';
const RoutingRulesSelectRow = ({
  anyAvailableUser,
  disabled,
  disableKeepAssigneeOption,
  routingRules,
  hasRoutingAccess,
  aiChatbotId,
  showAnyUserOption,
  showKeepAssigneeOption,
  showUnassignedOption,
  showOwnerOption,
  onOpenChange,
  onRuleUpdate,
  FormControl,
  workSpace,
  isUngatedForHelpDeskRoutingScopeFiltering,
  hasEditAccess
}) => {
  const onRoutingTypeChange = evt => {
    const rotationMethod = getRotationMethod(routingRules) || undefined;
    onRuleUpdate(evt.target.value === KEEP_ASSIGNEE ? evt.target.value : buildRoutingRulesFromType(evt.target.value, {
      aiChatbotId,
      rotationMethod
    }));
  };
  const currentGroup = getType(routingRules) || KEEP_ASSIGNEE;
  const selectDisabled = isUngatedForHelpDeskRoutingScopeFiltering ? !hasEditAccess || disabled : !hasRoutingAccess || disabled;
  return /*#__PURE__*/_jsx(RuleBox, {
    FormControl: FormControl,
    label: /*#__PURE__*/_jsx(AssignmentLabel, {
      workSpace: workSpace,
      hasEditAccess: hasEditAccess,
      isUngatedForHelpDeskRoutingScopeFiltering: isUngatedForHelpDeskRoutingScopeFiltering
    }),
    className: "selectTypeRow",
    children: /*#__PURE__*/_jsx(SelectAssignmentGroup, {
      anyAvailableUser: anyAvailableUser,
      currentGroup: currentGroup,
      disableKeepAssignee: disableKeepAssigneeOption,
      onChange: onRoutingTypeChange,
      onOpenChange: onOpenChange,
      aiChatbotId: aiChatbotId,
      showAnyUser: showAnyUserOption,
      showKeepAssignee: showKeepAssigneeOption,
      showUnassigned: showUnassignedOption,
      showOwner: showOwnerOption,
      disabled: selectDisabled
    })
  });
};
RoutingRulesSelectRow.displayName = 'RoutingRulesSelectRow';
export default RoutingRulesSelectRow;